<template>
  <div class="login-enter-code">
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <div v-else>
      <img class="image-container" :src="require('@/assets/hero-login.svg')">
      <div class="content">
        <enter-code :phone-number="phoneNumber"
                    :confirm-code-action="validateCodeAndProceed"
                    :regenerate-code-action="generateCode"
                    :server-error="serverErrors.validateCode"
                    :button-title="'כניסה'"
                    :loading="loading"
                    :reset-error="() => resetError('validateCode')"/>
        <login-support-footer :link-action="openLoginHelpModal" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import router from '@/router';
import EnterCode from '../../../../base-components/EnterCode.vue';
import Segment from '../../../../Segment';
import CookiesDisabledError from '../../../general-errors/CookiesDisabledError.vue';
import LoginHelp from './steps/LoginHelp.vue';
import ModalBus from '../../../../event-bus/modal-bus';

export default {
  name: 'LoginEnterCode',
  components: {
    LoginSupportFooter: BaseUI.LoginSupportFooter,
    EnterCode,
    CookiesDisabledError,
  },
  data() {
    return {
      redirectTo: '',
      loading: false,
    };
  },
  created() {
    this.redirectTo = this.$route.query.redirectTo || 'sr';
    if (!this.phoneNumber) {
      if (this.$route.query.phoneNumber) {
        this.setPhoneNumber(this.$route.query.phoneNumber);
      } else {
        this.redirectToLogin();
      }
    }
    Segment.trackUserGot('LoginEnterCodeEntered');
  },
  computed: {
    ...mapState('login', ['phoneNumber', 'serverErrors']),
    ...mapGetters('login', ['errorTypes']),
    cookiesDisabledError() {
      return this.serverErrors.validateCode === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapMutations('login', ['resetError', 'setPhoneNumber']),
    ...mapActions('login', ['validateCode', 'generateCode']),
    ...mapState('login', ['phoneNumber']),
    redirectToOldState() {
      const carryParams = _.omit(this.$route.query, ['redirectTo', 'phoneNumber']);
      router.push({ path: `/${this.redirectTo}`, query: carryParams });
    },
    redirectToLogin() {
      router.push({ path: '/login', query: this.$route.query });
    },
    async validateCodeAndProceed(code) {
      Segment.trackUserInteraction('LoginCodeEnteredClicked');
      try {
        this.loading = true;
        await this.validateCode(code);
        this.redirectToOldState();
      } finally {
        this.loading = false;
      }
    },
    openLoginHelpModal() {
      ModalBus.$emit('open', {
        component: LoginHelp,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .error-holder {
    margin: 30px;
  }

  .login-enter-code {
    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }
  }
</style>
